import { ApiEndpoint } from 'controller/endpoint'
import { HttpRequestForApiV4 } from 'utils/http'
import { IPerformerData } from 'meta/pages/v4/performer'

type Props = {
  code: string
}

type Response = IPerformerData

export const getData = async (props: Props): Promise<Response> => {
  const { code } = props

  const endpoint = ApiEndpoint.v4.performer.data(code)

  const { data } = await HttpRequestForApiV4.get<Response>(endpoint)
  return data
}
